import {role} from "@/components/mock/base/const.js";
export default {
  menu:
  [
    {
        id: "home",
        href: [{type:"default", to:"/philips/home"}],
        title: "ホーム",
        icon: "mdi mdi-home mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_headOffice_sales,
          role.role_headOffice_division,
          role.role_headOffice_sw,
          role.role_salesOffice,
          role.role_psc,
          role.role_kawagoe,
          role.role_kawagoe_cpap,
          role.role_call_center,
          role.role_headOffice_call,
          role.role_ndss,
        ]
      },
      {
        id: "cpapApplication",
        href: [{ type: "default", to: "/philips/cpap/RequestSearch" }],
        title: "CPAP案件検索",
        icon: "mdi mdi-text-box-multiple-outline mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_salesOffice,
          role.role_kawagoe_cpap,
          role.role_call_center,
          role.role_headOffice_call,
        ]
      },
      {
        id: "cpap",
        href: [{ type: "default", to: "/philips/cpap/cpapHome" }],
        title: "CPAP処方・配送サービス",
        img: "cpap-icon.png",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_salesOffice,
        ]
      },
      {
        id: "careOrchestrator",
        href: [{type:"default", to:"/philips/careorchestrator/COHome"}],
        title: "ケアオーケストレーター",
        img: "care_orchestrator-icon.png",
        roleList: [
          role.role_admin,
          role.role_headOffice_sw,
          role.role_salesOffice
        ]
      },
      {
        id: "application",
        href: [{type:"default", to:"/philips/search/RequestSearch"}],
        title: "検査案件検索",
        icon: "mdi mdi-magnify mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_headOffice_sales,
          role.role_headOffice_division,
          role.role_salesOffice,
          role.role_psc,
          role.role_kawagoe,
          role.role_call_center,
          role.role_headOffice_call
        ]
      },
      {
        id: "offer ",
        href: [{type:"default", to:"/philips/offer/offerHome"}],
        title: "検査/解析申込み",
        icon: "mdi mdi-offer mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_salesOffice
        ]
      },
      {
         id: "shippingCalender",
         href: [{type:"default", to:"/philips/calender/ShippingCalender"}],
         title: "出荷カレンダー",
         icon: "mdi mdi-calendar-blank mdi-48px",
         iconOverlay: "mdi mdi-truck mdi-20px",
         roleList: [
           role.role_admin,
           role.role_headOffice_division,
           role.role_kawagoe
         ]
      },
      {
        id: "hst",
        href: [{type:"default", to:"/philips/hst/HSTRequestAccept"}],
        title: "睡眠検査機器配送ｻｰﾋﾞｽ",
        icon: "mdi mdi-hospital-building mdi-48px",
        roleList: [
          role.role_admin,
          role.role_kawagoe
        ]
      },
      {
        id: "kenshin",
        href: [{type:"default", to:"/philips/kenshin/KenshinDivisionRequestAccept"},{type:role.role_kawagoe, to:"/philips/kenshin/KenshinRequestAccept"}],
        title: "企業検診",
        icon: "mdi mdi-office-building mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice_division,
          role.role_kawagoe
        ]
      },
      {
        id: "profile",
        href: [
          { type: "default", to:"/philips/device/DeviceManagement" },
          { type: role.role_salesOffice, to:"/philips/device/ReturnDelayedManagement" },
          { type: role.role_headOffice, to:"/philips/call/CpapFollowUpCallList" },
          { type: role.role_call_center, to:"/philips/call/CpapFollowUpCallList" },
          { type: role.role_headOffice_call, to:"/philips/call/CpapFollowUpCallList" },
        ],
        title: "機器／コール管理",
        icon: "mdi mdi-devices mdi-48px",
        roleList: [
          role.role_admin,
          role.role_kawagoe,
          role.role_salesOffice,
          role.role_headOffice,
          role.role_call_center,
          role.role_headOffice_call,
        ]
      },
      {
        id: "holter",
        href: [{type:"default", to:"/philips/holter/HolterRequestAccept"}],
        title: "ホルター心電図配送ｻｰﾋﾞｽ",
        icon: "mdi mdi-heart-pulse mdi-48px",
        roleList: [
          role.role_admin,
          role.role_kawagoe
        ]
      },
      {
        id: "psg",
        href: [{type:"default", to:"/philips/psg/PSGRequestAccept"}],
        title: "PSG解析",
        icon: "mdi mdi-pulse mdi-48px",
        roleList: [
          role.role_admin,
          role.role_psc
        ]
      },
      {
        id: "holterAnalysis",
        href: [{type:"default", to:"/philips/holterAnalysis/HolterAnalysisRequestAccept"}],
        title: "ホルター心電図解析",
        icon: "mdi mdi-clipboard-outline mdi-48px",
        iconOverlay: "mdi mdi-heart-pulse mdi-20px",
        roleList: [
          role.role_admin,
          role.role_psc
        ]
      },
      {
        id: "profile",
        href: [{type:"default", to:"/philips/spreadSheet/menu"}],
        title: "集計表",
        icon: "mdi mdi-text-box-search-outline mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_headOffice_division,
          role.role_salesOffice,
          role.role_psc,
          role.role_kawagoe
        ]
      },
      {
        id: "PortalSetting",
        href: [{ type: "default", to: "/philips/portal-setting" }],
        title: "ポータル設定",
        icon: "mdi mdi-message-cog-outline mdi-48px",
        roleList: [
          role.role_admin,
        ]
      },
      {
        id: "ExternalUserControlSearch",
        href: [{type:"default", to:"/philips/user/ExternalUserControlSearch"}],
        title: "外部ユーザー管理",
        icon: "mdi mdi-account-plus mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_salesOffice,
          role.role_headOffice_division,
          role.role_headOffice_sw,
        ]
      },
      {
        id: "profile",
        href: [{type:"default", to:"/philips/profile/UserProfile"}],
        title: "ユーザープロファイル",
        icon: "mdi mdi-account-cog mdi-48px",
        roleList: [
          role.role_admin,
          role.role_headOffice,
          role.role_headOffice_sales,
          role.role_headOffice_division,
          role.role_headOffice_sw,
          role.role_salesOffice,
          role.role_psc,
          role.role_kawagoe,
          role.role_kawagoe_cpap,
          role.role_call_center,
          role.role_headOffice_call,
          role.role_ndss,
        ]
      },
      {
        id: "maint",
        href: [{type:"default", to:"/philips/master/user/InternalUserSearch"}],
        title: "メンテナンス",
        icon: "mdi mdi-grid mdi-48px",
        roleList: [
          role.role_admin
        ]
      },
      {
        id: "dataManagement",
        href: [{ type: "default", to: "/philips/dataManagement" }],
        title: "マスタデータ管理",
        icon: "mdi mdi-folder-cog-outline mdi-48px",
        roleList: [
          role.role_admin,
          role.role_ndss,
        ]
      }
  ]
}


// WEBPACK FOOTER //
// ./src/components/mock/philips/menu.js